import React from 'react';
import { HeadlineTitle } from '../../components/Title';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';
import * as T from '../../components/Typography';
import GraphicBurst from '../../components/GraphicBurst';
import Button from '../../components/Button';

import { navRoutes } from '../../constants';
import { graphicBurstsBottom, graphicBurstsTop } from './data';

const WhoJoinTC = ({
  language,
  title,
  subTitleTop,
  descriptionTop,
  subTitleBottom,
  descriptionBottom,
}) => {
  return (
    <SectionLayout bgcolor="gray2">
      {/* TOP SECTION */}
      <Row>
        <Col w={[4, 6, 10]}>
          <HeadlineTitle>{title}</HeadlineTitle>
        </Col>
        <Col w={[4, 6, 9]}>
          <T.H4 color="midnight" mt={5} mtT={4} mtM={3}>
            {subTitleTop}
          </T.H4>
        </Col>
        <Col w={[4, 6, 8]}>
          <T.P16 color="black3" mt={3} mtT={2} mtM={1}>
            {descriptionTop}
          </T.P16>
        </Col>
      </Row>
      <Row jcT="center">
        {graphicBurstsTop.map(card => (
          <Col w={[4, 3, 4]} mt={4} mtM={3}>
            <GraphicBurst
              image={card.image}
              title={language === 'welsh' ? card.titleWelsh : card.titleEnglish}
            />
          </Col>
        ))}
      </Row>
      <Row>
        <Col w={[4, 3, 4]} mt={4}>
          <Button color="blue" small external to={navRoutes.earnGroupsForm} caps={false}>
            {language === 'welsh' ? 'Ymunwch â’r rhwydwaith' : 'Join the network'}
          </Button>
        </Col>
        <Col w={[4, 3, 4]} mt={4}>
          <Button color="pink" small to={navRoutes.earnGroupsHome}>
            {language === 'welsh' ? 'Darllenwch fwy' : 'Read more'}
          </Button>
        </Col>
      </Row>
      {/* BOTTOM SECTION */}
      <Row mt={5}>
        <Col w={[4, 6, 10]}>
          <HeadlineTitle />
        </Col>
        <Col w={[4, 6, 9]}>
          <T.H4 color="midnight" mt={5} mtT={4} mtM={3}>
            {subTitleBottom}
          </T.H4>
        </Col>
        <Col w={[4, 6, 8]}>
          <T.P16 color="black3" mt={3} mtT={2} mtM={1}>
            {descriptionBottom}
          </T.P16>
        </Col>
      </Row>
      <Row jcT="center">
        {graphicBurstsBottom.map(card => (
          <Col w={[4, 3, 4]} mt={4} mtM={3}>
            <GraphicBurst
              image={card.image}
              title={language === 'welsh' ? card.titleWelsh : card.titleEnglish}
            />
          </Col>
        ))}
      </Row>
      <Row>
        <Col w={[4, 3, 4]} mt={4}>
          <Button color="blue" small external to={navRoutes.spendPartnerForm}>
            {language === 'welsh' ? 'Ymunwch â’r rhwydwaith' : 'Join the network'}
          </Button>
        </Col>
        <Col w={[4, 3, 4]} mt={4}>
          <Button color="pink" small to={navRoutes.spendPartnerHome}>
            {language === 'welsh' ? 'Darllenwch fwy' : 'Read more'}
          </Button>
        </Col>
      </Row>
    </SectionLayout>
  );
};

export default WhoJoinTC;
